<template>
  <ALink :to="blok.link" class="inline-block">
    <AButton :icon="icon" :size="size" :variant="variant" :text="blok.label" />
  </ALink>
</template>

<script setup lang="ts">
import { ElementButtonStoryblok } from '@/types';
import { Fa6SolidIcon } from '@/types';
import { PropsButtonBase } from '@/components/atoms/AButtonBase.vue';

interface Props {
  blok: ElementButtonStoryblok;
  size?: PropsButtonBase['size'];
  variant?: PropsButtonBase['variant'];
}
const props = defineProps<Props>();

type IconCms = Fa6SolidIcon | '';
const icon = computed(() => {
  const selectedIcon = props.blok.icon as IconCms;
  if (selectedIcon) return selectedIcon;
  return undefined;
});
</script>
